import { render, staticRenderFns } from "./InvoicePDF.vue?vue&type=template&id=2a394016&scoped=true"
import script from "./InvoicePDF.vue?vue&type=script&lang=js"
export * from "./InvoicePDF.vue?vue&type=script&lang=js"
import style0 from "./InvoicePDF.vue?vue&type=style&index=0&id=2a394016&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a394016",
  null
  
)

export default component.exports